'use client';
import { Button, Typography } from '@mui/material';
import * as React from 'react';
import { useSeriesByIdStore } from '../../store/series-by-id-store';
import { hasCustomerSeriesAccess } from '../../utils/return-customer-series-access';

const PurchaseSingleSeries: React.FC<{
  onClick: () => void;
  seriesDocumentId: string;
  redirectURL: string | undefined | null;
}> = ({ onClick, seriesDocumentId, redirectURL }) => {
  const { customerSubscription } = useSeriesByIdStore();

  const ownsContent = hasCustomerSeriesAccess(
    seriesDocumentId,
    customerSubscription?.data?.purchasedSeries,
    !!customerSubscription?.data?.subscriber,
  );
  if (customerSubscription?.status?.isLoading || ownsContent) return null;
  return (
    <Button
      onClick={() => onClick()}
      disabled={!redirectURL}
      variant="contained"
      color="secondary"
      fullWidth
    >
      <Typography variant="button-m">Acquista il corso singolo</Typography>
    </Button>
  );
};

export default PurchaseSingleSeries;
